// src/components/MobileOrderPage.js
import React, { useState, useEffect, useCallback, useRef } from "react";
import axios from "axios";
import { useReactToPrint } from 'react-to-print';
import './MobileOrderPage.css'; // We'll create this CSS file
import { useLocation } from "react-router-dom";

const url = process.env.REACT_APP_SERVER_URL || "https://food.stall-centralsoft.com";
//const stallID = localStorage.getItem("stallID");
//const username = localStorage.getItem("username");

export default function CustomerMenu() {
   const location = useLocation();
  const params = new URLSearchParams(location.search);
 const stallID =
    params.get("stallID") || localStorage.getItem("stallID");

  const stallName =
    params.get("stallName") || localStorage.getItem("username");

  const [foods, setFoods] = useState([]);
  const [categories, setCategories] = useState([]);
  const [cart, setCart] = useState([]);
  const [tableNumber, setTableNumber] = useState("");
  const [availableAddons, setAvailableAddons] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [loading, setLoading] = useState(true);
  const [showOrderConfirmation, setShowOrderConfirmation] = useState(false);
  const [currentOrder, setCurrentOrder] = useState(null);

  const printRef = useRef();

  // Simple placeholder image
  const PLACEHOLDER = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='150' viewBox='0 0 200 150'%3E%3Crect width='200' height='150' fill='%23f8f9fa'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='Arial' font-size='14' fill='%236c757d'%3ENo Image%3C/text%3E%3C/svg%3E";

  // Clean image URL function
  const getImageUrl = (imagePath) => {
    if (!imagePath || imagePath === "null" || imagePath === "undefined") {
      return PLACEHOLDER;
    }

    // If it's already a full URL, return it
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
      return imagePath;
    }

    // If it's a data URL, return it
    if (imagePath.startsWith('data:')) {
      return imagePath;
    }

    // Clean the path
    let cleanPath = imagePath.trim();
    
    // Remove leading slash if present
    if (cleanPath.startsWith('/')) {
      cleanPath = cleanPath.substring(1);
    }
    
    // Ensure it starts with 'uploads/'
    if (!cleanPath.startsWith('uploads/')) {
      cleanPath = 'uploads/' + cleanPath;
    }
    
    // Return full URL
    return `${url}/${cleanPath}`;
  };

  // Safe numeric conversion
  const getSafePrice = (p) => {
    if (p === null || p === undefined || p === "") return 0;
    const n = Number(p);
    return Number.isFinite(n) ? n : 0;
  };

  // Safe toFixed function
  const safeToFixed = (value, decimals = 2) => {
    const num = getSafePrice(value);
    return num.toFixed(decimals);
  };

  // Print handler
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    pageStyle: `
      @media print {
        body {
          font-family: 'Courier New', monospace;
          font-size: 12px;
          margin: 0;
          padding: 5px;
        }
        .no-print { display: none !important; }
        .print-only { display: block !important; }
        .kitchen-ticket {
          width: 80mm;
          border: 1px solid #000;
          padding: 8px;
          margin: 0 auto;
          background: white;
        }
        * {
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
      }
      @media screen {
        .print-only { display: none !important; }
      }
    `,
    documentTitle: `Order-${currentOrder?.orderId || ''}`
  });

  // Fetch foods and addons
  useEffect(() => {

 console.log("stallID:", stallID);
console.log("stallName:", stallName);




    const fetchAll = async () => {
      try {
        setLoading(true);
        
        // Fetch foods
        const foodsRes = await axios.get(`${url}/api/admin/foods`, {
          params: { stallID }
        });

        const foodsData = foodsRes.data.foods || foodsRes.data || [];
        
        // Process foods
        const processedFoods = foodsData.map((food) => {
          const basePrice = getSafePrice(food.prom_price) > 0 
            ? getSafePrice(food.prom_price) 
            : getSafePrice(food.price);
            
          return {
            id: String(food.id || food.ID || food._id),
            foodName: food.foodName || food.name || "Unnamed Food",
            description: food.description || "",
            price: getSafePrice(food.price),
            prom_price: getSafePrice(food.prom_price),
            basePrice,
            imageURL: food.imageURL || food.image || "",
            category: food.category || "Uncategorized",
          };
        });

        setFoods(processedFoods);

        // Extract unique categories
        const uniqueCategories = [...new Set(processedFoods.map(f => f.category))];
        setCategories(["All", ...uniqueCategories]);

        // Fetch addons
        const addonsRes = await axios.get(`${url}/api/admin/addons`, {
          params: { stallID }
        });

        const addonsData = addonsRes.data.addons || addonsRes.data || [];
        
        const processedAddons = addonsData.map(addon => ({
          id: String(addon.id || addon.ID || addon._id),
          name: addon.name || addon.addonName || "Addon",
          price: getSafePrice(addon.price || addon.addonPrice),
          category: addon.category || "extra",
        }));

        setAvailableAddons(processedAddons);

      } catch (err) {
        console.error("Error fetching menu:", err);
        alert("Failed to load menu. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    if (stallID) {
      fetchAll();
    } else {
      alert("Stall Not Been Register");
      setLoading(false);
    }

  },[]);

  // Add to cart function
  const addToCart = useCallback((food) => {
    setCart((prev) => {
      const existingItem = prev.find(item => String(item.id) === String(food.id));
      
      if (existingItem) {
        return prev.map(item =>
          String(item.id) === String(food.id)
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }

      const newItem = {
        id: String(food.id),
        foodName: food.foodName,
        basePrice: food.basePrice,
        price: food.price,
        prom_price: food.prom_price,
        quantity: 1,
        selectedAddons: [],
        addonsTotal: 0,
        finalPrice: food.basePrice,
        notes: "",
      };
      
      return [...prev, newItem];
    });
  }, []);

  // Update item quantity
  const updateItemQuantity = useCallback((itemId, change) => {
    setCart((prev) =>
      prev
        .map((item) =>
          String(item.id) === String(itemId)
            ? { ...item, quantity: Math.max(1, item.quantity + change) }
            : item
        )
        .filter(item => item.quantity > 0)
    );
  }, []);

  // Remove item completely
  const removeItem = useCallback((itemId) => {
    setCart((prev) => prev.filter(item => String(item.id) !== String(itemId)));
  }, []);

  // Handle addon selection
  const handleAddonDropdown = useCallback((itemId, addonId) => {
    if (!addonId) return;

    setCart((prev) =>
      prev.map((item) => {
        if (String(item.id) !== String(itemId)) return item;

        const addon = availableAddons.find(a => String(a.id) === String(addonId));
        if (!addon) return item;

        const existingAddonIndex = item.selectedAddons.findIndex(a => String(a.id) === String(addonId));
        let updatedAddons = [...item.selectedAddons];

        if (existingAddonIndex >= 0) {
          updatedAddons[existingAddonIndex] = {
            ...updatedAddons[existingAddonIndex],
            quantity: updatedAddons[existingAddonIndex].quantity + 1,
          };
        } else {
          updatedAddons.push({ ...addon, quantity: 1 });
        }

        const addonsTotal = updatedAddons.reduce((sum, a) => sum + (a.price * a.quantity), 0);

        return {
          ...item,
          selectedAddons: updatedAddons,
          addonsTotal,
          finalPrice: (item.basePrice * item.quantity) + addonsTotal,
        };
      })
    );
  }, [availableAddons]);

  // Update addon quantity
  const updateAddonQuantity = useCallback((itemId, addonId, change) => {
    setCart((prev) =>
      prev.map((item) => {
        if (String(item.id) !== String(itemId)) return item;

        let updatedAddons = item.selectedAddons.map((a) =>
          String(a.id) === String(addonId)
            ? { ...a, quantity: Math.max(0, a.quantity + change) }
            : a
        );

        updatedAddons = updatedAddons.filter(a => a.quantity > 0);

        const addonsTotal = updatedAddons.reduce((sum, a) => sum + (a.price * a.quantity), 0);

        return {
          ...item,
          selectedAddons: updatedAddons,
          addonsTotal,
          finalPrice: (item.basePrice * item.quantity) + addonsTotal,
        };
      })
    );
  }, []);

  // Update notes
  const updateNotes = useCallback((itemId, notes) => {
    setCart((prev) =>
      prev.map((item) =>
        String(item.id) === String(itemId) ? { ...item, notes } : item
      )
    );
  }, []);

  // Calculate item total
  const calculateItemTotal = useCallback((item) => {
    return item.finalPrice || (item.basePrice * item.quantity) + (item.addonsTotal || 0);
  }, []);

  // Cart total
  const cartTotal = cart.reduce((sum, item) => sum + calculateItemTotal(item), 0);

  // Submit order
  const submitOrder = async () => {
    if (!tableNumber.trim()) {
      alert("Please enter table number");
      return;
    }
    if (cart.length === 0) {
      alert("Cart is empty");
      return;
    }

    try {
      const orderData = {
        stallID: stallID,
        tableNumber: tableNumber.trim(),
        total: cartTotal,
        status: "pending",
      };

      const orderRes = await axios.post(`${url}/api/admin/orders`, orderData);

      if (orderRes.data.success) {
        const orderId = orderRes.data.orderId;

        // Prepare and send order items
        for (const item of cart) {
          const addonsText = item.selectedAddons.length > 0
            ? `Add-ons: ${item.selectedAddons.map(a => `${a.quantity} × ${a.name}`).join(", ")}`
            : "";

          const notes = item.notes 
            ? (addonsText ? `${item.notes} | ${addonsText}` : item.notes)
            : addonsText;

          const itemData = {
            stallID,
            orderId,
            foodId: item.id,
            foodName: item.foodName,
            quantity: item.quantity,
            unitPrice: getSafePrice(item.basePrice),
            notes,
          };

          await axios.post(`${url}/api/admin/order-items`, itemData);
        }

        // Set current order for confirmation
        setCurrentOrder({
          orderId,
          stallID,
          tableNumber,
          totalAmount: cartTotal,
          orderTime: new Date().toLocaleString('en-MY')
        });

        setShowOrderConfirmation(true);
        setCart([]);
        setTableNumber("");

      } else {
        alert("Failed to create order");
      }
    } catch (err) {
      console.error("Order error:", err);
      alert("Error placing order. Please try again.");
    }
  };

  // Back to menu function
  const handleBackToMenu = () => {
    setShowOrderConfirmation(false);
    setCurrentOrder(null);
  };

  // Filter foods by category
  const filteredFoods = selectedCategory === "All"
    ? foods
    : foods.filter(food => food.category === selectedCategory);

  // Order Confirmation Component
  const OrderConfirmation = ({ order, onBack, onPrint, printRef }) => {
    return (
      <div className="container-fluid">
        <div className="no-print mb-4">
          <button className="btn btn-secondary me-2" onClick={onBack}>
            ← Back to Menu
          </button>
          <button className="btn btn-primary" onClick={onPrint}>
            🖨️ Print Receipt
          </button>
        </div>

        {/* Printable Receipt */}
        <div ref={printRef} className="kitchen-ticket">
          <div style={{ textAlign: "center", marginBottom: "10px", borderBottom: "1px solid #000", paddingBottom: "8px" }}>
            <h2 style={{ margin: "0", fontSize: "16px", fontWeight: "bold" }}>{stallID?.toUpperCase()} KITCHEN</h2>
            <p style={{ margin: "2px 0", fontSize: "10px" }}>ORDER RECEIPT</p>
          </div>

          <div style={{ marginBottom: "8px", borderBottom: "1px dashed #000", paddingBottom: "8px" }}>
            <p style={{ margin: "2px 0", fontSize: "10px" }}><strong>Order #:</strong> {order.orderId}</p>
            <p style={{ margin: "2px 0", fontSize: "10px" }}><strong>Table #:</strong> {order.tableNumber}</p>
            <p style={{ margin: "2px 0", fontSize: "10px" }}><strong>Time:</strong> {order.orderTime}</p>
          </div>

          <div style={{ marginBottom: "8px" }}>
            <p style={{ margin: "2px 0", fontSize: "10px", fontWeight: "bold" }}>Order Placed Successfully!</p>
          </div>

          <div style={{ borderTop: "2px solid #000", paddingTop: "8px", textAlign: "center" }}>
            <p style={{ margin: "2px 0", fontSize: "11px", fontWeight: "bold" }}>
              TOTAL: RM {safeToFixed(order.totalAmount)}
            </p>
          </div>

          <div style={{ textAlign: "center", marginTop: "10px", fontSize: "8px" }}>
            <p>*** KITCHEN COPY ***</p>
            <p>Thank you for your order!</p>
          </div>
        </div>

        {/* Screen Confirmation */}
        <div className="no-print mt-4">
          <div className="alert alert-success">
            <h4 className="alert-heading">✅ Order Placed Successfully!</h4>
            <p><strong>Order ID:</strong> {order.orderId}</p>
            <p><strong>Table Number:</strong> {order.tableNumber}</p>
            <p><strong>Total Amount:</strong> RM {safeToFixed(order.totalAmount)}</p>
            <p><strong>Order Time:</strong> {order.orderTime}</p>
          </div>
        </div>
      </div>
    );
  };

  // Loading state
  if (loading) {
    return (
      <div className="mobile-menu-page">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <span>Loading menu...</span>
        </div>
      </div>
    );
  }

  // Order confirmation view
  if (showOrderConfirmation && currentOrder) {
    return (
      <OrderConfirmation
        order={currentOrder}
        onBack={handleBackToMenu}
        onPrint={handlePrint}
        printRef={printRef}
      />
    );
  }

  // Main menu view
  return (
    <div className="mobile-menu-page">
      {/* Header */}
      <header className="mobile-header">
        <h1>🍽️ Food Ordering</h1>
        <div className="stall-info">
          Stall: <strong>{stallName}</strong> | ID: <strong>{stallID}</strong>
        </div>
        <div className="table-number-section">
          <div className="table-input-group">
            <label className="table-label">📋 TABLE NUMBER 桌號 *</label>
            <input
              type="text"
              className="table-input"
              value={tableNumber}
              onChange={(e) => setTableNumber(e.target.value)}
              placeholder="e.g., T01"
              required
            />
            {!tableNumber && (
              <div className="table-warning">Please enter your table number</div>
            )}
          </div>
        </div>
      </header>

      {/* Category Filter */}
      <div className="category-filter">
        <button
          className={`category-btn ${selectedCategory === "All" ? "active" : ""}`}
          onClick={() => setSelectedCategory("All")}
        >
          All ({foods.length})
        </button>
        {categories.filter(c => c !== "All").map((category) => (
          <button
            key={category}
            className={`category-btn ${selectedCategory === category ? "active" : ""}`}
            onClick={() => setSelectedCategory(category)}
          >
            {category} ({foods.filter(f => f.category === category).length})
          </button>
        ))}
      </div>

      {/* Menu Items in 2 Columns */}
      <div className="menu-grid">
        {filteredFoods.length > 0 ? (
          filteredFoods.map((food) => {
            const imageUrl = getImageUrl(food.imageURL);
            
            return ( 
             <div key={food.id} className="food-card">
                {/* Food Image */}
                <div className="food-image-container">
                  <img
                    src={imageUrl}
                    alt={food.foodName}
                    className="card-img-top"
                    style={{ height: "180px", width: "200px", objectFit: "cover" }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = PLACEHOLDER;
                    }}
                  />
                </div>
          

                <div className="food-content">
                  <h3 className="food-name">{food.foodName}</h3>
                  <p className="food-description">{food.description}</p>

                  <div className="price-section">
                    {food.prom_price > 0 ? (
                      <>
                        <span className="original-price">RM {safeToFixed(food.price)}</span>
                        <span className="promo-price">RM {safeToFixed(food.prom_price)}</span>
                      </>
                    ) : (
                      <span className="normal-price">RM {safeToFixed(food.price)}</span>
                    )}
                  </div>

                  <button
                    className="add-to-cart-btn"
                    onClick={() => addToCart(food)}
                  >
                    + Order Now 立即訂購食物
                  </button>
                </div>
              </div>
            );
          })
        ) : (
          <div className="no-food-message">
            <p>No food items available in "{selectedCategory}" category.</p>
            <button 
              className="btn btn-outline-primary"
              onClick={() => setSelectedCategory("All")}
            >
              View All Items
            </button>
          </div>
        )}
      </div>

      {/* Fixed Cart at Bottom */}
      <div className="mobile-cart">
        <div className="cart-header">
          <div className="cart-title">
            🛒 Your Cart
            <span className="item-count">
              ({cart.reduce((total, item) => total + item.quantity, 0)} items)
            </span>
          </div>
          <div className="cart-total-amount">RM {safeToFixed(cartTotal)}</div>
        </div>

        <div className="cart-items">
          {cart.length === 0 ? (
            <div className="empty-cart">Cart is empty</div>
          ) : (
            cart.map((item) => (
              <div key={item.id} className="cart-item">
                <div className="cart-item-header">
                  <span className="item-name">{item.foodName}</span>
                  <div className="item-quantity-controls">
                    <button
                      className="qty-btn"
                      onClick={() => updateItemQuantity(item.id, -1)}
                    >
                      -
                    </button>
                    <span className="item-quantity">{item.quantity}</span>
                    <button
                      className="qty-btn"
                      onClick={() => updateItemQuantity(item.id, +1)}
                    >
                      +
                    </button>
                    <button
                      className="remove-btn"
                      onClick={() => removeItem(item.id)}
                    >
                      🗑
                    </button>
                  </div>
                </div>

                {/* Addons Dropdown */}
                <div className="addon-dropdown">
                  <select
                    className="addon-select"
                    defaultValue=""
                    onChange={(e) => {
                      handleAddonDropdown(item.id, e.target.value);
                      e.target.value = "";
                    }}
                  >
                    <option value="">+ Add an add-on 添加附加材料...</option>
                    {availableAddons.map((addon) => (
                      <option key={addon.id} value={addon.id}>
                        {addon.name} (+RM {safeToFixed(addon.price)})
                      </option>
                    ))}
                  </select>
                </div>

                {/* Selected Addons */}
                {item.selectedAddons.length > 0 && (
                  <div className="selected-addons">
                    <div className="addons-title">Customizations:</div>
                    {item.selectedAddons.map((a) => (
                      <div key={a.id} className="addon-item">
                        <span className="addon-name">{a.name}</span>
                        <div className="addon-controls">
                          <button
                            className="addon-qty-btn"
                            onClick={() => updateAddonQuantity(item.id, a.id, -1)}
                          >
                            -
                          </button>
                          <span className="addon-quantity">{a.quantity}</span>
                          <button
                            className="addon-qty-btn"
                            onClick={() => updateAddonQuantity(item.id, a.id, +1)}
                          >
                            +
                          </button>
                        </div>
                        <span className="addon-price">+RM {safeToFixed(a.price * a.quantity)}</span>
                      </div>
                    ))}
                    {item.addonsTotal > 0 && (
                      <div className="addons-total">
                        Add-ons total: +RM {safeToFixed(item.addonsTotal)}
                      </div>
                    )}
                  </div>
                )}

                {/* Notes Input */}
                <div className="notes-section">
                  <input
                    type="text"
                    className="notes-input"
                    placeholder="Special instructions 特別指示..."
                    value={item.notes || ""}
                    onChange={(e) => updateNotes(item.id, e.target.value)}
                  />
                </div>

                {/* Item Total */}
                <div className="item-total">
                  <span className="total-amount">Item Total: RM {safeToFixed(calculateItemTotal(item))}</span>
                </div>
              </div>
            ))
          )}
        </div>

        {cart.length > 0 && (
          <button
            className="place-order-btn"
            onClick={submitOrder}
            disabled={!tableNumber.trim()}
          >
            📋 Place Order  下單 - RM {safeToFixed(cartTotal)}
          </button>
        )}
      </div>
    </div>
  );
}